import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import UnidadesForm from "./UnidadesForm"
import { HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class UnidadesModal extends Component {
  constructor() {
    super()
    this.callBackUnidades = this.callBackUnidades.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getUnidadesOrcametarias((unidades, error) => {
      if (unidades) {
        this.props.callBack(unidades)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  callBackUnidades() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <UnidadesForm callBackUnidades={this.callBackUnidades} />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/UnidadesModal.js